import { Facebook, Instagram, Linkedin } from "lucide-react";

const SOCIALS = [
  { key: "facebook", Icon: Facebook, color: "#1877F2", label: "Facebook" },
  { key: "instagram", Icon: Instagram, color: "#E4405F", label: "Instagram" },
  { key: "linkedin", Icon: Linkedin, color: "#0A66C2", label: "LinkedIn" },
];

const GREY = "#C9C3B8";

function normalizeUrl(v) {
  if (!v) return null;
  const t = String(v).trim();
  if (!t) return null;
  return /^https?:\/\//i.test(t) ? t : `https://${t}`;
}

export function SocialLinks({ socials, iconClass = "w-5 h-5", gap = "gap-3", onClickStop = false }) {
  return (
    <div className={`flex items-center ${gap}`} data-testid="social-links">
      {SOCIALS.map(({ key, Icon, color, label }) => {
        const url = normalizeUrl(socials?.[key]);
        if (url) {
          return (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onClickStop ? (e) => e.stopPropagation() : undefined}
              aria-label={label}
              title={label}
              data-testid={`social-link-${key}`}
              className="transition-transform duration-300 hover:scale-110"
              style={{ color }}
            >
              <Icon className={iconClass} strokeWidth={1.9} />
            </a>
          );
        }
        return (
          <span
            key={key}
            aria-label={`${label} not linked`}
            title={`${label} not linked`}
            data-testid={`social-disabled-${key}`}
            style={{ color: GREY }}
          >
            <Icon className={iconClass} strokeWidth={1.9} />
          </span>
        );
      })}
    </div>
  );
}
